// Yeni sipariş/bildirim geldiğinde çalınan, sevimli iki-üç notalı bir "ding" sesi — harici bir ses
// dosyasına ihtiyaç duymadan Web Audio API ile üretiliyor (hem Android hem iOS Safari'de çalışır).
// Titreşim ise yalnızca Android'de mümkün (iOS Safari Vibration API'yi hiç desteklemiyor) — bu yüzden
// navigator.vibrate var mı diye kontrol edip öyle çağırıyoruz, iOS'ta sessizce atlanır.
let audioContext = null;

const contextAl = () => {
  if (!audioContext) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) audioContext = new AC();
  }
  if (audioContext && audioContext.state === 'suspended') {
    audioContext.resume().catch(() => {});
  }
  return audioContext;
};

// Tarayıcıların otomatik ses çalma kısıtlamasını aşmak için, sayfadaki İLK kullanıcı
// tıklamasında/dokunmasında ses bağlamını "kilidini aç" (sessizce). Bundan sonra programatik
// çalınan sesler sorunsuz çalışır.
export const sesKilidiniAc = () => {
  const ctx = contextAl();
  if (ctx && ctx.state === 'suspended') ctx.resume().catch(() => {});
};

const notaCal = (ctx, frekans, baslangic, sure) => {
  const osc = ctx.createOscillator();
  const kazanc = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = frekans;
  osc.connect(kazanc);
  kazanc.connect(ctx.destination);

  const t = ctx.currentTime + baslangic;
  kazanc.gain.setValueAtTime(0, t);
  kazanc.gain.linearRampToValueAtTime(0.25, t + 0.02);
  kazanc.gain.exponentialRampToValueAtTime(0.001, t + sure);

  osc.start(t);
  osc.stop(t + sure + 0.02);
};

export const bildirimSesiCal = () => {
  const ctx = contextAl();
  if (!ctx) return;
  // Yükselen, sevimli iki nota: "ding-dong" tarzı bir çan sesi.
  notaCal(ctx, 880, 0, 0.25);
  notaCal(ctx, 1174.66, 0.15, 0.3);
};

export const titret = () => {
  if (navigator.vibrate) {
    try { navigator.vibrate([180, 80, 180]); } catch { /* iOS zaten desteklemiyor, sessizce geç */ }
  }
};
